import { Button } from "@devhop/ui";
import { TrashIcon } from "lucide-react";
import type { OrderAttachmentDTO } from "@/modules/orders/domain/contracts";
import { AppImage } from "@/shared/ui/AppImage";
import { ImagePreviewModal } from "@/shared/ui/ImagePreviewModal";

export function nextAttachmentSortOrder(items: OrderAttachmentDTO[]): number {
  if (!items.length) return 0;
  return Math.max(...items.map((a) => a.sortOrder)) + 1;
}

export function OrderAttachmentGrid({
  items,
  canDelete,
  onDelete,
  isDeletingId,
  compact,
}: {
  items: OrderAttachmentDTO[];
  canDelete: boolean;
  onDelete: (id: string) => void;
  isDeletingId: string | null;
  /** แถว timeline ใช้ช่องแคบขึ้น */
  compact?: boolean;
}) {
  if (!items.length) {
    return <p className="text-muted-foreground text-xs">ຍັງບໍ່ມີຮູບ</p>;
  }
  return (
    <div
      className={
        compact
          ? "grid grid-cols-3 gap-2 sm:grid-cols-4"
          : "grid grid-cols-2 gap-3 sm:grid-cols-3"
      }
    >
      {items.map((att) => (
        <div key={att.id} className="group relative">
          <ImagePreviewModal
            fileKey={att.fileKey}
            title="ເບິ່ງຮູບແບບເຕັມຈໍ"
            triggerClassName="relative block w-full overflow-hidden rounded-md border bg-muted/20 p-0 text-left outline-none ring-offset-background transition-opacity hover:opacity-95 focus-visible:ring-2 focus-visible:ring-ring cursor-zoom-in"
          >
            <div className="aspect-square">
              <AppImage
                src={att.fileKey}
                alt=""
                className="size-full object-cover"
                showLoading={false}
              />
            </div>
          </ImagePreviewModal>
          {canDelete && (
            <Button
              type="button"
              variant="destructive"
              size="icon"
              className={`absolute z-10 opacity-0 transition-opacity group-hover:opacity-100 ${
                compact ? "top-1 right-1 size-7" : "top-2 right-2 size-8"
              }`}
              disabled={isDeletingId === att.id}
              onClick={() => onDelete(att.id)}
              title="ລຶບ"
            >
              <TrashIcon className={compact ? "size-3.5" : "size-4"} />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
}
